import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import errorImg from '../../assets/images/404-error.png';
import '../../assets/css/normalize.css';
import '../../assets/css/webflow.css';
import '../../assets/css/ibl-default-errors.webflow.css';
import '../../assets/css/custom.css';

interface IErrorProps {
  errorCode: number;
  header: string;
  message: string;
  subMessage: string;
  children?: ReactNode;
}
const Error = ({
  errorCode,
  header,
  message,
  subMessage,
  children,
}: IErrorProps) => {
  const { t } = useTranslation('library');

  return (
    <div className="w-layout-hflex-error-ui error-page-main-container">
      <div className="w-layout-hflex-error-ui error-page-layout">
        <div className="w-layout-hflex-error-ui error-page-left-side">
          <div className="w-layout-hflex-error-ui error-page-image-block">
            <img
              src={errorImg}
              loading="lazy"
              alt=""
              className="error-page-image"
            />
          </div>
        </div>
        <div className="w-layout-hflex-error-ui error-page-right-side">
          <h1 className="error-page-primary-heading">{errorCode}</h1>
          <h1 className="error-page-secondary-heading">{header}</h1>
          <div className="error-page-description">
            {message}
            <br />
            {subMessage}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
